import AudienceSettingsModal from './AudienceSettingsModal.Container';

export default AudienceSettingsModal;
